import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'AiCatalogItemField',
    mixins: [
        glSlotsMixin
    ],
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        value: {
            type: String,
            required: false,
            default: null
        }
    }
};
